<div *ngIf="settings.overlayClass" [ngClass]="[settings.overlayClass, animateOverlayClass]" (click)="(!actionButtons || !actionButtons.length) && close()"></div>
<div [ngClass]="[settings.modalClass, animateModalClass]">
  <div [ngClass]="settings.modalDialogClass">
    <div [ngClass]="[ showAlert ? settings.alertClass : '', settings.contentClass]">
      <div [ngClass]="settings.headerClass">
        <h4 [ngClass]="settings.headerTitleClass">{{title}}</h4>
        <button (click)="close()" *ngIf="!actionButtons || !actionButtons.length" type="button" [title]="settings.closeButtonTitle"
          [ngClass]="settings.closeButtonClass">
          <svg width="16" height="16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000"
            enable-background="new 0 0 1000 1000" xml:space="preserve">
            <g>
              <path d="M892.1,9.9l97.9,98L107.9,990.1L10,892L892.1,9.9z" />
              <path d="M107.9,9.9L990,892l-97.9,98L10,108L107.9,9.9z" />
            </g>
          </svg>
        </button>
      </div>
      <div [ngClass]="settings.bodyClass">
        <i #modalDialogBody></i>
      </div>
      <div [ngClass]="settings.footerClass" *ngIf="actionButtons && actionButtons.length">
        <button *ngFor="let button of actionButtons" (click)="doAction(button.onAction)" [ngClass]="button.buttonClass || settings.buttonClass">{{button.text}}
        </button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-modal-dialog/achoo-modal-dialog.component.html